/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { ListBotsStatus200, ListBotsStatus500 } from '../types/ListBots'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listBots } from '../clients/listBots'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listBotsQueryKey = () => [{ url: '/v1/bots' }] as const

type ListBotsQueryKey = ReturnType<typeof listBotsQueryKey>

export function listBotsQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listBotsQueryKey()
  return queryOptions<
    ListBotsStatus200,
    ResponseErrorConfig<ListBotsStatus500>,
    ListBotsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listBots({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary List all bots
 * {@link /v1/bots}
 */
export function useListBots<
  TData = ListBotsStatus200,
  TQueryData = ListBotsStatus200,
  TQueryKey extends QueryKey = ListBotsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListBotsStatus200,
        ResponseErrorConfig<ListBotsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listBotsQueryKey()

  const queryResult = useQuery(
    {
      ...listBotsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<ListBotsStatus500>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
